import { render, staticRenderFns } from "./EcommerceFilter.vue?vue&type=template&id=1aec3e4f&"
import script from "./EcommerceFilter.vue?vue&type=script&lang=js&"
export * from "./EcommerceFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports